module.exports = __webpack_public_path__ + "media/src/assets/images/lps-car-7afa858c21bf92d112dda0bc25035b61.png";